import { integration } from "@/utils/constants";
import { handleResponse, handleError } from "@/utils/functions";

export default (axios) => ({
  getIntegrationItemList(params) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${integration.itemBase}`, { params: params })
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  getIntegrationLogsDetail(id) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${integration.logsDetailsBase}${id}`)
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  successfullyItemIntegrationUpdated(id) {
    return new Promise((resolve, reject) => {
      axios
        .patch(`${integration.itemBase}${id}/set_success/`)
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  successfullyCustomerIntegrationUpdated(id) {
    return new Promise((resolve, reject) => {
      axios
        .patch(`${integration.customerBase}${id}/set_success/`)
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  successfullyOrderIntegrationUpdated(id) {
    return new Promise((resolve, reject) => {
      axios
        .patch(`${integration.orderBase}${id}/set_success/`)
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  getIntegrationItemDetails(id) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${integration.itemBase}${id}/`)
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  getIntegrationCustomerList(params) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${integration.customerBase}`, { params: params })
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  getIntegrationCustomerDetails(id) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${integration.customerBase}${id}/`)
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  getIntegrationOrderList(params) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${integration.orderBase}`, { params: params })
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  getIntegrationOrderDetails(id) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${integration.orderBase}${id}/`)
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
});
